import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';

const NAME = 'Footer';

class Footer extends BaseComponent {
	constructor(element) {
		super(element);
		this.startIndex = 0;
		this.allowedItems = 7;
		this.visibleClass = 'is-visible';
		this.timer = 3000;
		this.pointer = this.startIndex;
		this.visibleElements = [];
		this.sponsorsElements = SelectorEngine.find('.js-lta-footerv2-supporters ul, .js-lta-footerv2-partners ul', this._element);
		this.linksElements = SelectorEngine.find('.js-lta-footerv2-links', this._element);
		this.init();
		this.startAnimation();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		for (const item of this.linksElements)
			item.addEventListener('click', () => {
				item.classList.toggle('collapsible--expanded');
			});
	}

	startAnimation() {
		this.addVisibleClass();
		for (const item of this.sponsorsElements) {
			if (item.children.length > this.allowedItems) {
				setInterval(() => {
					this.animate();
				}, this.timer);
			}
		}
	}

	animate() {
		// Updating/Setting the pointer
		this.pointer = this.pointer + this.allowedItems;
		for (const item of this.sponsorsElements) {
			if (this.pointer > item.children.length - 1) {
				this.pointer = this.startIndex;
			}

			// Hiding the current visible elements
			this.removeVisibleClass();

			// Makes the new element visible
			this.addVisibleClass();
		}
	}

	addVisibleClass() {
		for (const item of this.sponsorsElements) {
			if (!item) {
				return;
			}
			for (let index = this.pointer; index < this.pointer + this.allowedItems; index++) {
				if (item.children[index]) {
					this.visibleElements.push(item.children[index]);
					this.visibleElements[this.visibleElements.length - 1].classList.add(this.visibleClass);
				}
			}
		}
	}

	removeVisibleClass() {
		for (const element of this.visibleElements) {
			element.classList.remove(this.visibleClass);
		}
		this.visibleElements = [];
	}
}

export default Footer;
